var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"outlined":"","small":"","color":_vm.updateByClient ? 'red' : 'green'}},[_vm._v("\n  "+_vm._s(_vm.updateByClient ? "Самостійно" : "Tqm Systems")+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }